var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnBrowsingSoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-browsingsoftware",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(9.238 12.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 6.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(38.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(10.824 56.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(19.398 24.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icn",
    transform: "translate(23.462 25.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn-deceptors",
    transform: "translate(0 0)",
    opacity: 0.995
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M1164.829,1349.113h-3.786l-.748-3.028h-9.875l-.748,3.028h-3.786a1.328,1.328,0,1,0,0,2.656h18.944a1.328,1.328,0,1,0,0-2.656Z",
    transform: "translate(-1138.074 -1317.117)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12332",
    "data-name": "Path 12332",
    d: "M1449.807,73.772s7.631-.163,8.99,5.4-2.718,13.407-1.568,18.312l3.554-4.251V73.609S1449.7,73.772,1449.807,73.772Z",
    transform: "translate(-1429.334 -71.127)",
    fill: "#00aafc",
    opacity: 0.077
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12333",
    "data-name": "Path 12333",
    d: "M1430.662,88.593s6.691,15.5,20.9,15.732h-21.366Z",
    transform: "translate(-1427.826 -79.347)",
    fill: "#00aafc",
    opacity: 0.077
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M1109,1075h-28.429a3.084,3.084,0,0,0-3.075,3.075v21.28a3.061,3.061,0,0,0,3.061,3.06h28.429a3.084,3.084,0,0,0,3.075-3.075v-21.28A3.07,3.07,0,0,0,1109,1075Zm-.026,21.205a1.742,1.742,0,0,1-1.742,1.742h-7.967a1.474,1.474,0,0,0-1.4,1.022,1.024,1.024,0,0,1-.975.71h-4.217a1.024,1.024,0,0,1-.975-.71,1.475,1.475,0,0,0-1.4-1.022h-7.96a1.754,1.754,0,0,1-1.749-1.749v-16.523a1.742,1.742,0,0,1,1.742-1.742h24.9a1.754,1.754,0,0,1,1.749,1.749Z",
    transform: "translate(-1077.5 -1075)",
    fill: "#007dba"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "www",
    transform: "translate(31.821 29.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12901",
    "data-name": "Path 12901",
    d: "M5628.118,2013c-.312-.034-.625-.063-.937-.1a8.509,8.509,0,0,1-2.959-.961,8.945,8.945,0,0,1-3.4-3.184,8.518,8.518,0,0,1-.906-1.952c.338,0,.663.023.984-.006a.519.519,0,0,1,.641.4,6.369,6.369,0,0,0,.483.909c.042.076.089.09.181.086.361-.015.724-.009,1.085-.01h.222c-.111-.463-.218-.907-.328-1.365h1.4c.119.412.239.813.349,1.217a.178.178,0,0,0,.208.151q3.293-.006,6.584,0a.178.178,0,0,0,.208-.152c.111-.4.23-.8.349-1.217h1.4c-.11.458-.217.9-.329,1.365a10.281,10.281,0,0,1,1.113.01.434.434,0,0,0,.5-.293c.152-.321.322-.634.472-.956a.194.194,0,0,1,.206-.138c.426.007.852,0,1.305,0-.084.227-.151.442-.241.647a8.887,8.887,0,0,1-6.135,5.278,14.662,14.662,0,0,1-1.639.246l-.188.03Zm3.112-3.444h-5.576a.278.278,0,0,0,.015.063,4.935,4.935,0,0,0,1.219,1.429,2.422,2.422,0,0,0,1.752.564,2.745,2.745,0,0,0,1.563-.753A5.275,5.275,0,0,0,5631.23,2009.56Zm1.009,1.031a6.257,6.257,0,0,0,1.347-1.024,6.976,6.976,0,0,0-.715-.017.134.134,0,0,0-.1.059C5632.6,2009.922,5632.432,2010.237,5632.239,2010.591Zm-7.67,0,.036-.047c-.166-.305-.331-.612-.5-.915a.157.157,0,0,0-.1-.079c-.241-.007-.482,0-.723,0l-.026.063Z",
    transform: "translate(-5619.554 -1995.078)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12902",
    "data-name": "Path 12902",
    d: "M5965.643,1887.171c-.364.82-.734,1.637-1.086,2.462a.393.393,0,0,1-.435.28c-.631-.022-.494.082-.755-.5-.172-.386-.339-.775-.526-1.2-.062.146-.107.257-.157.365-.175.381-.356.76-.527,1.144a.279.279,0,0,1-.294.2c-.157-.008-.314,0-.473,0a.234.234,0,0,1-.24-.165c-.338-.825-.68-1.649-1.017-2.474-.076-.187-.014-.275.192-.28.181-.005.362,0,.543,0a.258.258,0,0,1,.282.2c.149.442.309.88.465,1.319.023.065.05.13.086.224.035-.075.061-.125.083-.176.2-.454.4-.907.589-1.364a.3.3,0,0,1,.32-.208c.686.012.53-.079.793.521.149.342.29.687.436,1.031.021.051.047.1.083.179.2-.519.4-1,.577-1.494a.3.3,0,0,1,.35-.236c.145.01.293-.011.437.007a1.164,1.164,0,0,1,.275.109Z",
    transform: "translate(-5947.795 -1879.476)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12903",
    "data-name": "Path 12903",
    d: "M5637.512,1679.246c-.453,0-.9,0-1.349-.006-.046,0-.107-.072-.136-.124-.2-.37-.388-.744-.577-1.118a.223.223,0,0,0-.258-.135c-.343.022-.688.008-1.033.008h-.229l.327,1.363h-1.4c-.115-.4-.233-.795-.342-1.193a.2.2,0,0,0-.227-.174q-3.284.007-6.567,0a.187.187,0,0,0-.216.164c-.109.4-.227.794-.345,1.2h-1.4l.327-1.364a9.47,9.47,0,0,1-1.076-.009.489.489,0,0,0-.567.336c-.144.312-.3.619-.457.924-.026.051-.092.117-.141.118-.442.009-.886.005-1.332.005a8.925,8.925,0,0,1,16.991,0Zm-5.718-2.75a.373.373,0,0,0-.017-.071,4.658,4.658,0,0,0-1.51-1.625,2.257,2.257,0,0,0-2.51,0,4.646,4.646,0,0,0-1.509,1.626.215.215,0,0,0-.011.07Zm1.083-1.04-.034.049c.166.305.332.611.5.916.018.032.055.075.084.075.245.006.491,0,.736,0l.026-.063Zm-7.671,0a7.2,7.2,0,0,0-1.393,1.043c.291,0,.528,0,.764,0a.134.134,0,0,0,.094-.06C5624.844,1676.126,5625.014,1675.812,5625.205,1675.459Z",
    transform: "translate(-5620.132 -1673.058)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12904",
    "data-name": "Path 12904",
    d: "M5788.635,1888.712c.2-.51.4-.994.572-1.487a.315.315,0,0,1,.363-.242c.163.011.327,0,.49.005s.236.1.169.255c-.365.838-.732,1.677-1.109,2.51a.333.333,0,0,1-.227.146c-.154.023-.314,0-.472.009a.271.271,0,0,1-.293-.193c-.185-.44-.379-.877-.569-1.315-.023-.053-.047-.106-.084-.187-.036.075-.063.128-.088.182-.2.445-.408.89-.609,1.336a.259.259,0,0,1-.27.177c-.158-.006-.315,0-.473,0a.252.252,0,0,1-.264-.183c-.334-.82-.674-1.638-1.009-2.457-.077-.188-.018-.274.189-.28.181-.005.362,0,.543,0a.258.258,0,0,1,.282.2c.153.452.318.9.479,1.35.019.053.04.105.072.192.038-.079.063-.128.084-.179.2-.454.4-.906.59-1.363a.288.288,0,0,1,.3-.2c.707.013.541-.083.809.522.155.352.3.709.448,1.063C5788.583,1888.61,5788.605,1888.65,5788.635,1888.712Z",
    transform: "translate(-5778.581 -1879.473)",
    fill: "#00aafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12905",
    "data-name": "Path 12905",
    d: "M5612.2,1888.28c-.226.492-.451.964-.658,1.443a.355.355,0,0,1-.387.244c-.687-.02-.529.092-.794-.539-.289-.687-.569-1.379-.852-2.068-.1-.233-.045-.313.2-.317.175,0,.35,0,.525,0a.25.25,0,0,1,.269.2c.153.452.317.9.478,1.351.019.053.041.106.076.2.042-.09.072-.148.1-.207.2-.449.393-.9.583-1.347a.269.269,0,0,1,.279-.19c.728.011.561-.091.833.537.168.384.327.772.5,1.192.033-.073.058-.12.077-.169.175-.451.354-.9.52-1.354a.271.271,0,0,1,.3-.205c.175.006.35,0,.525,0s.248.1.176.264c-.365.839-.732,1.676-1.11,2.51-.03.067-.141.1-.214.144,0,0-.011,0-.017,0-.652.033-.653.033-.918-.571-.143-.325-.282-.652-.424-.978C5612.249,1888.373,5612.226,1888.334,5612.2,1888.28Z",
    transform: "translate(-5609.46 -1879.53)",
    fill: "#00aafc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBrowsingSoftware);
export default __webpack_public_path__ + "static/media/icn-browsing-software.8044a71413d405b45e57adf370dc836e.svg";
export { ForwardRef as ReactComponent };